<script setup lang="ts">

import CarbucksProtectFeatures from './Components/CarbucksProtectFeatures.vue';

</script>

<template>

    <Page>
   
        <div class="flex justify-center items-center gap-4 2xl:gap-16 -my-6">

            <div class="flex flex-col items-center 2xl:-top-4 3xl:-top-6">
                <CarbucksProtectFeatures />
            </div>

        </div>

        <KeyMessage animation="push-up">
            <div class="pt-4 2xl:pt-0 2xl:text-2xl">
                Customers return to the dealership to have the repairs completed
            </div>
        </KeyMessage>

    </Page>

</template>